import { memo } from "react";
import { ComposedGesture, GestureType } from "react-native-gesture-handler";
import PhotoDisplay from "src/screens/(internal)/PhotoDetailModal/components/MainPhotoItem/components/MainPhotoItemContent/components/PhotoDisplay";
import usePhotoDetailStore from "src/screens/(internal)/PhotoDetailModal/stores/usePhotoDetailStore";
import { PhotoItem } from "src/screens/(internal)/PhotoDetailModal/types";

const MainPhotoItemContent = ({
	photo,
	boundingWidth,
	boundingHeight,
	isInitial,
	mainContentGesture,
}: {
	photo: PhotoItem;
	isInitial: boolean;
	boundingWidth: number;
	boundingHeight: number;
	mainContentGesture: ComposedGesture | GestureType;
}) => {
	const variant = photo.variant;
	const setDidLoad = usePhotoDetailStore((state) => state.setDidLoad);
	const isSelected = usePhotoDetailStore((state) => state.curPhoto?.photoId === photo.photoId);
	return (
		<PhotoDisplay
			photo={photo}
			boundingWidth={boundingWidth}
			boundingHeight={boundingHeight}
			isActive={isSelected}
			onLoad={({ success }) => {
				setDidLoad(
					{
						photoId: photo.photoId,
					},
					{
						isInitial,
						success,
						didFail: !success,
					},
				);
			}}
			onDetailedLoad={({ success }) => {
				setDidLoad(
					{
						photoId: photo.photoId,
					},
					{
						isInitial,
						success,
						didFail: !success,
						didLoadDetailed: true,
					},
				);
			}}
		/>
	);
};
export default memo(MainPhotoItemContent);
